/**
 * Pro Tune — Megamenu Produtos dinâmico
 */
(function () {
  'use strict';

  var CACHE = new Map();
  var PRODUCT_LIMIT = 6;
  var initialized = new WeakSet();

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function extractHandle(href) {
    if (!href) return null;
    var m = href.match(/\/collections\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }

  function thumbUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.[a-z]+)(\?[^\.]*)?$/i, '_300x$1$2');
  }

  function buildProductCard(product) {
    var link = '/products/' + product.handle;
    var image = (product.images && product.images[0]) || product.featured_image;
    var imageUrl = typeof image === 'string' ? image : (image ? image.src : null);
    var price = product.price !== undefined
      ? formatMoney(product.price)
      : (product.price_min !== undefined ? formatMoney(product.price_min) : '');

    var a = document.createElement('a');
    a.className = 'protune-megamenu-product';
    a.href = link;

    var imgWrap = document.createElement('div');
    imgWrap.className = 'protune-megamenu-product__image-wrapper';
    if (imageUrl) {
      var img = document.createElement('img');
      img.className = 'protune-megamenu-product__image';
      img.src = thumbUrl(imageUrl);
      img.alt = product.title || '';
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }

    var title = document.createElement('p');
    title.className = 'protune-megamenu-product__title';
    title.textContent = product.title || '';

    var priceEl = document.createElement('p');
    priceEl.className = 'protune-megamenu-product__price';
    priceEl.textContent = price;

    a.appendChild(imgWrap);
    a.appendChild(title);
    a.appendChild(priceEl);
    return a;
  }

  function showLoading(container) {
    container.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'protune-megamenu-loading';
    for (var i = 0; i < PRODUCT_LIMIT; i++) {
      var sk = document.createElement('div');
      sk.className = 'protune-megamenu-skeleton';
      wrap.appendChild(sk);
    }
    container.appendChild(wrap);
  }

  function showEmpty(container) {
    container.innerHTML = '';
    var empty = document.createElement('div');
    empty.className = 'protune-megamenu-empty';
    empty.textContent = 'Nenhum produto encontrado nesta coleção.';
    container.appendChild(empty);
  }

  function renderProducts(container, products) {
    container.innerHTML = '';
    if (!products || products.length === 0) { return showEmpty(container); }
    var grid = document.createElement('div');
    grid.className = 'protune-megamenu-products';
    products.slice(0, PRODUCT_LIMIT).forEach(function (p) { grid.appendChild(buildProductCard(p)); });
    container.appendChild(grid);
  }

  function fetchCollectionProducts(handle) {
    if (CACHE.has(handle)) return Promise.resolve(CACHE.get(handle));
    var url = '/collections/' + handle + '/products.json?limit=' + PRODUCT_LIMIT;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
      .then(function (data) { var products = (data && data.products) || []; CACHE.set(handle, products); return products; })
      .catch(function (err) { console.warn('[ProTune megamenu] Falha ao buscar:', handle, err); return []; });
  }

  function setActiveLink(listEl, link) {
    var links = listEl.querySelectorAll('.mega-menu__link');
    for (var i = 0; i < links.length; i++) { links[i].classList.toggle('is-active-category', links[i] === link); }
  }

  function loadCategory(link, contentEl, listEl) {
    var handle = extractHandle(link.getAttribute('href'));
    if (!handle || !contentEl) return;
    setActiveLink(listEl, link);
    if (!CACHE.has(handle)) { showLoading(contentEl); }
    fetchCollectionProducts(handle).then(function (products) { renderProducts(contentEl, products); });
  }

  function initMegaMenu(megaMenuRoot) {
    if (initialized.has(megaMenuRoot)) return;
    var listEl = megaMenuRoot.querySelector('.mega-menu__list');
    var contentEl = megaMenuRoot.querySelector('.mega-menu__content');
    if (!listEl || !contentEl) return;
    var links = listEl.querySelectorAll('.mega-menu__link');
    if (links.length === 0) return;
    initialized.add(megaMenuRoot);
    var firstHandle = extractHandle(links[0].getAttribute('href'));
    if (firstHandle) {
      fetchCollectionProducts(firstHandle).then(function (products) {
        if (!contentEl.querySelector('.protune-megamenu-products')) { renderProducts(contentEl, products); setActiveLink(listEl, links[0]); }
      });
    }
    for (var i = 0; i < links.length; i++) {
      (function (link) {
        link.addEventListener('mouseenter', function () { loadCategory(link, contentEl, listEl); });
        link.addEventListener('focus', function () { loadCategory(link, contentEl, listEl); });
      })(links[i]);
    }
  }

  function initAll() {
    var megaMenus = document.querySelectorAll('.menu-list__submenu .mega-menu, header-menu .mega-menu');
    for (var i = 0; i < megaMenus.length; i++) { initMegaMenu(megaMenus[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.matches && (node.matches('header-component, header-menu') || node.querySelector('.mega-menu')))) { initAll(); return; }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();



/* ─────────────────────────────────────────────────────────────
   Pro Tune — Infos de pagamento nos cards de listagem (coleções)
   Ordem: PIX → preço cheio riscado (CSS) → parcelamento
   PIX: -5%  |  Parcelamento: até 12x sem juros, mín. R$ 99/parcela
   ─────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var MAX_PARCELAS = 10;
  var PARCELA_MIN  = 99;
  var PIX_DESCONTO = 0.05;
  var ATTR_DONE    = 'data-pt-pay';

  function parseReal(texto) {
    if (!texto) return 0;
    return parseFloat(texto.replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
  }

  function formatReal(v) {
    return 'R$\u00a0' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function lerPreco(card) {
    var seletores = [
      '[data-block-type="price"] .price__regular .price',
      '[data-block-type="price"] .price',
      '.price__regular .price',
      '.price__regular span[class*="price"]',
      'sale-price',
      '.price-item--regular',
      '.price-item--sale',
    ];
    for (var i = 0; i < seletores.length; i++) {
      var el = card.querySelector(seletores[i]);
      if (!el) continue;
      var cents = el.getAttribute && el.getAttribute('data-money-cents');
      if (cents) { var p = parseFloat(cents) / 100; if (p > 0) return p; }
      var p2 = parseReal(el.textContent);
      if (p2 > 0) return p2;
    }
    return 0;
  }

  // Cria linha de PIX (vai ANTES do bloco de preço)
  function criarPix(preco) {
    var pixPreco = preco * (1 - PIX_DESCONTO);
    var div = document.createElement('div');
    div.className = 'protune-card-pix';

    var label = document.createElement('span');
    label.className = 'protune-card-pix__label';
    label.textContent = 'PIX';

    var valor = document.createElement('span');
    valor.className = 'protune-card-pix__valor';
    valor.textContent = formatReal(pixPreco);

    var desconto = document.createElement('span');
    desconto.className = 'protune-card-pix__desconto';
    desconto.textContent = '(-5%)';

    div.appendChild(label);
    div.appendChild(valor);
    div.appendChild(desconto);
    return div;
  }

  // Cria linha de parcelamento (vai DEPOIS do bloco de preço)
  function criarParcelas(preco) {
    var maxParcelas = Math.min(MAX_PARCELAS, Math.floor(preco / PARCELA_MIN));
    if (maxParcelas < 1) maxParcelas = 1;
    var div = document.createElement('div');
    div.className = 'protune-card-installments';
    div.textContent = maxParcelas > 1
      ? (maxParcelas + 'x ' + formatReal(preco / maxParcelas) + ' s/ juros')
      : 'à vista no cartão';
    return div;
  }

  function injetarNoCard(card) {
    if (card.hasAttribute(ATTR_DONE)) return;
    var preco = lerPreco(card);
    if (!preco) return;

    var blocoPreco = card.querySelector('[data-block-type="price"]')
                  || card.querySelector('.price__regular')
                  || card.querySelector('sale-price');
    if (!blocoPreco || !blocoPreco.parentNode) return;

    // PIX: inserir ANTES do bloco de preço
    blocoPreco.parentNode.insertBefore(criarPix(preco), blocoPreco);

    // Parcelas: inserir DEPOIS do bloco de preço
    blocoPreco.parentNode.insertBefore(criarParcelas(preco), blocoPreco.nextSibling);

    card.setAttribute(ATTR_DONE, '1');
  }

  function injetarTodos() {
    var cards = document.querySelectorAll('product-card:not([' + ATTR_DONE + '])');
    for (var i = 0; i < cards.length; i++) { injetarNoCard(cards[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', injetarTodos); }
  else { setTimeout(injetarTodos, 0); }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('product-card[' + ATTR_DONE + ']').forEach(function (c) {
      c.removeAttribute(ATTR_DONE);
      ['.protune-card-pix', '.protune-card-installments'].forEach(function (sel) {
        var el = c.querySelector(sel);
        if (el) el.parentNode.removeChild(el);
      });
    });
    injetarTodos();
  });

  if (typeof MutationObserver !== 'undefined') {
    var esperarDOM = function () {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { setTimeout(injetarTodos, 60); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', esperarDOM); }
    else { esperarDOM(); }
  }
})();
